import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSparks20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSparks20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.515 1.155a.75.75 0 0 0-.75.75 1.88 1.88 0 0 1-1.878 1.88h-.002a.75.75 0 1 0 0 1.5 1.88 1.88 0 0 1 1.88 1.88.75.75 0 0 0 1.5 0 1.88 1.88 0 0 1 1.879-1.88.75.75 0 0 0 0-1.5 1.88 1.88 0 0 1-1.879-1.88.75.75 0 0 0-.75-.75M6.5 4.142a.75.75 0 0 0-.75.75 3.936 3.936 0 0 1-3.933 3.935h-.003a.75.75 0 1 0 0 1.5h.003a3.935 3.935 0 0 1 3.933 3.936.75.75 0 0 0 1.5 0 3.936 3.936 0 0 1 3.935-3.936.75.75 0 0 0 0-1.5A3.936 3.936 0 0 1 7.25 4.892a.75.75 0 0 0-.75-.75m7.958 6.976a.75.75 0 0 1 .75.75v1.343a.75.75 0 0 1-1.5 0v-1.343a.75.75 0 0 1 .75-.75m0 6.873a.75.75 0 0 1-.75-.75v-1.343a.75.75 0 0 1 1.5 0v1.343a.75.75 0 0 1-.75.75m2.687-2.687a.75.75 0 1 0 0-1.5h-1.343a.75.75 0 0 0 0 1.5zm-6.123-.75a.75.75 0 0 1 .75-.75h1.343a.75.75 0 0 1 0 1.5h-1.343a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSparks20Filled);
